import { useEffect, useState } from 'react'
import { fetchMapFreshness } from '../utils/annexation'
import '../styles/StaleMapBanner.css'

/**
 * Dire que la carte est en retard, plutôt que de la laisser croire à jour.
 *
 * Une carte figée qui a l'air vivante est un piège : un joueur qui voit une
 * région comme sienne alors qu'elle a changé de mains prendra une décision
 * fausse, et rien à l'écran ne l'aura averti. C'est arrivé cinq jours durant,
 * sans qu'aucune interface ne le signale.
 *
 * Le bandeau n'apparaît QUE dans le cas de panne — carte ancienne ET
 * changements en attente. Un fichier ancien sur un monde calme est à jour et le
 * restera ; l'annoncer ferait passer l'avertissement au rouge chaque nuit sans
 * activité, et on apprendrait à l'ignorer avant la première vraie panne.
 */
const StaleMapBanner = () => {
  const [freshness, setFreshness] = useState(null)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    let alive = true
    // Une seule mesure au chargement, puis toutes les dix minutes : le retard
    // se compte en heures, le mesurer plus souvent n'apprendrait rien.
    const measure = () => fetchMapFreshness().then((data) => { if (alive) setFreshness(data) })
    measure()
    const timer = setInterval(measure, 10 * 60 * 1000)
    return () => { alive = false; clearInterval(timer) }
  }, [])

  if (!freshness?.stale || dismissed) return null

  const heures = Math.round((freshness.age_seconds || 0) / 3600)
  const attente = freshness.pending_changes

  return (
    <div className="stale-map-banner" role="status">
      <span className="stale-map-icon" aria-hidden="true">⏳</span>
      <div className="stale-map-text">
        <strong>Cette carte n’est plus à jour.</strong>
        <span>
          Elle date d’il y a {heures > 48 ? `${Math.round(heures / 24)} jours` : `${heures} h`}
          {attente ? ` et ${attente} changement${attente > 1 ? 's' : ''} attendent d’y être reportés` : ''}.
          Les frontières et les propriétaires affichés peuvent être faux.
        </span>
      </div>
      <button type="button" onClick={() => setDismissed(true)} aria-label="Masquer">×</button>
    </div>
  )
}

export default StaleMapBanner
